import { ViewType } from "@common/types/views/views";
import {
    OrganizationMemberAccessLogColumn,
    OrganizationMemberAccessLogView,
} from "@common/types/views/organizationMemberAccessLogView";

export function createDefaultMemberAccessLogView(): OrganizationMemberAccessLogView {
    return {
        type: ViewType.ORGANIZATION_MEMBER_ACCESS_LOG,
        columns: [
            { id: OrganizationMemberAccessLogColumn.MEMBER },
            { id: OrganizationMemberAccessLogColumn.CLIENT },
            { id: OrganizationMemberAccessLogColumn.SOURCE },
            { id: OrganizationMemberAccessLogColumn.CREATED_AT },
        ],
        filters: {},
    };
}
